import React from 'react'
import DocumentsComonent from '../Components/Documents/DocumentsComonent'

const Documents = () => {
  return (
    <>
      <DocumentsComonent/>
    </>
  )
}

export default Documents;